var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"single_page"},[_c('ol-map',{ref:"ol-map",attrs:{"lon":_vm.lon,"lat":_vm.lat,"mapid":_vm.mapid,"zoom":17},on:{"lonlat":_vm.lonlat}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }